import React from 'react'
import { Button } from 'lib/ui'
import Link from 'lib/components/Link'
import Router from 'next/router'

import useSessionUser from 'lib/hooks/useSessionUser'
import { isSubscriptionActive } from 'lib/util/subscription'
import { trackEvent } from 'lib/util/analytics'

const UserButton = ({ onClick }) => {
  const { auth, data, loading, error, signOut } = useSessionUser()

  if (error) return null

  // Same size as the logged-out buttons, so the header doesn't shift when auth
  // resolves for most visitors (MAD-111). Spans, not links: no SSR hrefs.
  if (loading)
    return (
      <>
        <Button as="span" inverted className="invisible" aria-hidden="true">
          Sign Up
        </Button>
        <Button
          as="span"
          inverted
          basic
          className="invisible"
          aria-hidden="true"
          style={{
            marginLeft: '0.5rem',
          }}
        >
          Login
        </Button>
      </>
    )

  if (auth) {
    const isSubscribed = isSubscriptionActive(data)

    if (isSubscribed) {
      return (
        <>
          <Link href="/user" passHref>
            <Button as="a" inverted onClick={onClick}>
              Your Settings
            </Button>
          </Link>
          <Button
            inverted
            basic
            onClick={() => {
              signOut()
              Router.push('/')
              if (onClick) onClick()
            }}
            style={{
              marginLeft: '0.5rem',
            }}
          >
            Logout
          </Button>
        </>
      )
    }

    return (
      <>
        <Link href="/subscribe" passHref>
          <Button as="a" primary onClick={onClick}>
            Subscribe — CA$3.99/mo
          </Button>
        </Link>
        <Link href="/user" passHref>
          <Button
            as="a"
            inverted
            basic
            onClick={onClick}
            style={{
              marginLeft: '0.5rem',
            }}
          >
            Settings
          </Button>
        </Link>
        <Button
          inverted
          basic
          onClick={() => {
            signOut()
            Router.push('/')
            if (onClick) onClick()
          }}
          style={{
            marginLeft: '0.5rem',
          }}
        >
          Logout
        </Button>
      </>
    )
  }

  return (
    <>
      <Link href="/configure" passHref>
        <Button
          as="a"
          inverted
          onClick={() => {
            trackEvent('cta_click', { source: 'header', topic: 'all' })
            if (onClick) onClick()
          }}
        >
          Sign Up
        </Button>
      </Link>
      <Link href="/login" passHref>
        <Button
          inverted
          basic
          as="a"
          style={{
            marginLeft: '0.5rem',
          }}
          onClick={onClick}
        >
          Login
        </Button>
      </Link>
    </>
  )
}

export default UserButton
